export const localeArr = ['en_GB', 'en_US', 'is_IS', 'pt_PT' , 'pt_BR', 'es_ES'] as const

export type Locale = typeof localeArr[number]
